import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.highRiskSupplementDetails;
export const highRiskSupplementsDetailsSelector = (state: RootState) => getState(state).data;
export const highRiskSupplementsDetailsIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const highRiskSupplementsDetailsErrorSelector = (state: RootState) => getState(state).error;
export const highRiskSupplementsDetailsIdSelector = (state: RootState) =>
  getState(state).activeEntryId;
